import React from 'react';

const Home = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" {...props}>
    <path
      fillRule="evenodd"
      d="M7 17v-4.002C7 11.894 7.888 11 9 11c1.105 0 2 .898 2 1.998V17h7V8L9 0 0 8v9h7z"
    />
  </svg>
);

export default Home;
